/**
 * Helpers de formatação/identificação de cartão de crédito (página pública de
 * pagamento). Funções puras — fáceis de testar e reusar.
 */

export const onlyDigits = (v) => String(v || "").replace(/\D/g, "");

// "#### #### #### ####" (até 16 dígitos)
export const maskCard = (v) => onlyDigits(v).slice(0, 16).replace(/(.{4})/g, "$1 ").trim();

// "MM/AA"
export const maskExpiry = (v) => {
	const n = onlyDigits(v).slice(0, 4);
	return n.length > 2 ? `${n.slice(0, 2)}/${n.slice(2)}` : n;
};

// CVV (3-4 dígitos)
export const maskCvv = (v) => onlyDigits(v).slice(0, 4);

// "000.000.000-00"
export const maskCpf = (v) =>
	onlyDigits(v).slice(0, 11)
		.replace(/(\d{3})(\d)/, "$1.$2")
		.replace(/(\d{3})(\d)/, "$1.$2")
		.replace(/(\d{3})(\d{1,2})$/, "$1-$2");

// Detecta a bandeira pelo prefixo (Visa tem precedência sobre Elo nos prefixos 4xxx).
export const detectBrand = (num) => {
	const n = onlyDigits(num);
	if (/^4/.test(n)) return "Visa";
	if (/^(5[1-5]|2[2-7])/.test(n)) return "Mastercard";
	if (/^3[47]/.test(n)) return "Amex";
	if (/^(4011|4312|4389|4514|4576|5041|5066|5067|509|6277|6362|6363|650|6516|6550)/.test(n)) return "Elo";
	if (/^(606282|3841)/.test(n)) return "Hipercard";
	return "";
};
